'use strict';
module.exports = require('./Tree.vue');